import React, { ReactNode } from 'react'

export const MVPLink = (props: { id?: string; className?: string; children: ReactNode; onClick?: () => void }) => {
	return (
		<button type='button' id={props.id} className={`mvp-link ${props.className}`} onClick={props.onClick}>
			{props.children}
		</button>
	)
}
